import React from 'react';
import HeroSection from './components/HeroSection';
import BenefitsSection from './components/BenefitsSection';
import TrustSignalsSection from './components/TrustSignalsSection';
import PlatformPreviewSection from './components/PlatformPreviewSection';
import CTASection from './components/CTASection';
import FooterSection from './components/FooterSection';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <HeroSection />
      <BenefitsSection />
      <TrustSignalsSection />
      <PlatformPreviewSection />
      <CTASection />
      <FooterSection />
    </div>
  );
};

export default LandingPage;